import { render } from "./Box.vue?vue&type=template&id=5e9c1669&scoped=true&ts=true"
import script from "./Box.vue?vue&type=script&lang=ts"
export * from "./Box.vue?vue&type=script&lang=ts"

import "./Box.vue?vue&type=style&index=0&id=5e9c1669&scoped=true&lang=scss"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e9c1669"]])

export default __exports__